// extracted by mini-css-extract-plugin
export var container = "collar-info-module--container--hIe34";
export var img = "collar-info-module--img--I7Rab";
export var text = "collar-info-module--text---DWW2";